function getEnvEnabledFeatures(env = {}, prefix = "REACT_APP_FEATURE_") {
  return Object.entries(env).reduce((prev, [key, value]) => (key.startsWith(prefix) && value.toLowerCase() === "true" && (prev[key.replace(prefix, "")] = !0), prev), {});
}
function mergeFeatures(current, additional) {
  const additionalAsGroup = featureGroupFromFlags(additional);
  return {
    ...current,
    ...additionalAsGroup
  };
}
function featureGroupFromFlags(features = {}) {
  return Array.isArray(features) ? Object.fromEntries(features.map((f) => [f, !0])) : features;
}
function isFeatureManager(obj) {
  return !!obj.addEventListener && !!obj.features && !!obj.updateFeature;
}
export {
  featureGroupFromFlags,
  getEnvEnabledFeatures,
  isFeatureManager,
  mergeFeatures
};
//# sourceMappingURL=utils.js.map
